import React from 'react';
import { Helmet } from 'react-helmet-async';

const LegalPageTemplate = ({ title, description, children }) => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{title} | Nubia Solar</title>
        <meta name="description" content={description} />
      </Helmet>

      <section className="py-24 bg-nubia-gray-light">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-nubia-green-primary mb-6">{title}</h1>
            <p className="text-xl text-nubia-text-dark/70 leading-relaxed">Información legal y de tratamiento de datos de Nubia Solar.</p>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto prose prose-lg prose-headings:text-nubia-green-primary prose-p:text-nubia-text-dark/80 prose-li:text-nubia-text-dark/80">
            {children}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPageTemplate;
